import Link from '@/components/ui/Link';
import { Database } from '@/types/database.types';
import { formatPrice } from '@/utils/formatPrice';
import { formatScreeningDate } from '@/utils/formatScreeningDate';
import { useTranslations } from 'next-intl';

export type Order = Database['public']['Functions']['get_user_orders']['Returns'][0];

interface OrderItem {
    ticket: {
        id: string;
        name: string;
        usage_limits: {
            online: number;
            in_cinema: number;
            single_use: boolean;
        };
        price: number;
    };
    screening?: {
        id: string;
        name: string;
    } | null;
    discount: number;
    quantity: number;
}

export default function OrderRowItem({ created_at, items, payment_receipt_url }: Order) {
    const t = useTranslations('Common');

    const orderItems = Array.isArray(items)
        ? items
        : typeof items === 'string'
          ? JSON.parse(items)
          : [];

    return (
        <div className="flex flex-col gap-5 py-5 border-b border-white/50 max-lg:w-fit">
            <div className="flex flex-col gap-5">
                {(orderItems as OrderItem[])?.map(
                    ({ ticket, discount, screening, quantity }, index) => {

                        const ticketPrice = ticket.price;
                        const discountAmount = discount ? (discount / 100) * ticketPrice : 0;
                        const finalPrice = Math.max(0, ticketPrice - discountAmount);
                        const price = formatPrice(finalPrice);
                        const name = screening?.name ? screening.name : ticket.name;

                        let type = '';
                        if (
                            ticket.usage_limits.single_use === true ||
                            ticket.usage_limits.online === 1 ||
                            ticket.usage_limits.in_cinema === 1
                        )
                            type = ticket.name;
                        if (
                            ticket.usage_limits.single_use === false ||
                            ticket.usage_limits.online > 1 ||
                            ticket.usage_limits.in_cinema > 1
                        )
                            type = t('pass');

                        return (
                            <div
                                className="flex items-center gap-5 lg:justify-between text-md lg:text-h6 uppercase text-white/50"
                                key={index}
                            >
                                <div className="max-w-[150px] min-w-[150px] w-full text-md lg:text-h6 uppercase">
                                    {!index && formatScreeningDate(created_at ?? '')}
                                </div>
                                <div className="max-w-[250px] min-w-[250px] w-full text-md lg:text-h6 uppercase text-white">
                                    {name}
                                </div>
                                <div className="max-w-[200px] min-w-[200px] w-full">{type}</div>
                                <div className="max-w-[100px] min-w-[100px] w-full">{quantity}</div>
                                <div className="max-w-[100px] min-w-[100px] w-full">{price}</div>
                                <div className="max-w-[100px] min-w-[100px] w-full text-primary">
                                    {!index && payment_receipt_url && (
                                        <Link
                                            className="text-primary"
                                            href={payment_receipt_url}
                                            target="_blank"
                                            title={t('receipt')}
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    },
                )}
            </div>
        </div>
    );
}
